const normalizeEmail = (email?: string): string => (email ?? '').trim().toLowerCase();

export const hasBuyerEmailChanged = (previousEmail?: string, nextEmail?: string): boolean => {
    const previous = normalizeEmail(previousEmail);
    return Boolean(previous) && previous !== normalizeEmail(nextEmail);
};
